export default __webpack_public_path__ + "static/cardsRowDiv4-0b29d14e6b521ad9a3c61cf51e4d49ea.png";